const SAFE_ADDITIONAL_RETURN_URL = /^\/[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*$/;

/** Allow only known internal card/list routes; never navigate an arbitrary login query value. */
export function safeReturnUrl(
  value: string | null | undefined,
  additionalAllowed: readonly string[] = [],
): string {
  if (!value || /[\\\x00-\x20\x7f]/.test(value)) return '/requests';
  if (SAFE_ADDITIONAL_RETURN_URL.test(value) && additionalAllowed.includes(value)) return value;
  if (/^\/(?:agentic\/)?decisions\/[A-Za-z0-9_-]+$/.test(value)) return value;
  if (/^\/insights\/[A-Za-z0-9_-]+$/.test(value)) return value;
  if (/^\/(?:spheres|work)\/[a-z0-9_]+\.[a-z0-9_]+$/.test(value)) return value;
  return ['/requests', '/requests/prepare', '/problems', '/insights', '/spheres', '/work'].includes(
    value,
  )
    ? value
    : '/requests';
}
